// Structured Data Generators for SEO

export const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Refine Studio",
    "url": "https://refinestudio.vercel.app",
    "logo": "https://refinestudio.vercel.app/logo.png",
    "description": "Professional web development and design services for global businesses",
    "address": {
        "@type": "PostalAddress",
        "addressCountry": "IN"
    },
    "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-820-864-6135",
        "contactType": "Customer Service",
        "availableLanguage": ["English"]
    },
    "sameAs": [
        "https://wa.me/918208646135"
    ]
};

export const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Refine Studio",
    "url": "https://refinestudio.vercel.app",
    "potentialAction": {
        "@type": "SearchAction",
        "target": "https://refinestudio.vercel.app/services?q={search_term_string}",
        "query-input": "required name=search_term_string"
    }
};

export const servicesSchema = [
    {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Web Development",
        "provider": {
            "@type": "Organization",
            "name": "Refine Studio"
        },
        "areaServed": "Worldwide",
        "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Web Development Services",
            "itemListElement": [
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "New Website Creation",
                        "description": "Custom website development from scratch"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Website Redesign",
                        "description": "Transform outdated websites into modern experiences"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Professional Catalogues",
                        "description": "Digital product catalogues for businesses"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Digital Banners & Graphics",
                        "description": "Eye-catching web graphics and banners"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Website Audit & Strategy",
                        "description": "Comprehensive website analysis and recommendations"
                    }
                }
            ]
        }
    }
];

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": item.url
    }))
});

export const faqSchema = (faqs: { question: string; answer: string }[]) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
        }
    }))
});
